exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".table-blue-wide td a[data-v-268568b8]{color:#557c84}", "", {"version":3,"sources":["F:/myugfront/src/components/program/program-module-subjects-table.vue"],"names":[],"mappings":"AACA,uCAAuC,aAAa,CACnD","file":"program-module-subjects-table.vue","sourcesContent":["\n.table-blue-wide td a[data-v-268568b8]{color:#557c84\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-268568b8","scoped":true,"sourceMap":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/program/program-module-subjects-table.vue
// module id = 1025
// module chunks = 11